import React, { useState, useEffect, useRef } from 'react';
import {Button } from "reactstrap";

import MapPicker from 'react-google-map-picker'

import '../Forms/Forms.css';
import parse from 'html-react-parser'; 

import * as Hosts from '../../../Hosts';
import {
    //set_language,
    reqGET,
	//reqPOST,
    reqFILE,
    //repo_banner_link,
    content_language,
    functionSendMail,
    simpleAxiosGet

} from '../../../Utils';

import { language } from '../WEBContent/Language';

import Swal from 'sweetalert2';

import Loader from '../../../loader';

//import Loader from '../../../loader';

const EnergyForm = (props) => {

    const [lang, set_lang] = useState('pt');
    const [lang_id, set_lang_id] = useState('1')

    const [, set_files_doc] = useState([]);
    const [files_doc_name, set_files_doc_name] = useState([]);
    const [file_url, set_file_url] = useState('')
    /*const [is_uploading, set_is_uploading] = useState(' d-none')*/
    const [upload_file, set_upload_file] = useState()
    const dados_config = useRef({})

    const data_interface = {
        id: '',
        info: {
            companycode: Hosts.companycode,
            name: '',
            email: '',
            tlf: '',
            nif: '',
            address: '',
            zip_code: '',
            location: '',
            gps_lat: '',
            gps_lng: '',
            type_user: 'consumer',
            subject: '',
            message: '',
            rgpd: false,    
            type: 'contact'
        }

    }

    const [ , set_dados ] = useState( null );
    const dados = useRef( data_interface );
    
    const [isloading, setLoading] = useState(true)

    // MAPA
    const gmaps_key = useRef({})
    const gmaps_georeverse_key = useRef({})
    const location_name = useRef([])
    const [defaultLocation, setDefaultLocation] = useState({});

    const [location, setLocation] = useState({});
    const [zoom, setZoom] = useState(18);

    const handleChangeLocation = async (lat, lng) => {
        setLocation({lat: lat, lng: lng});

        dados.current.info.gps_lat = lat
        dados.current.info.gps_lng = lng

        let aux_georeverse = await simpleAxiosGet('https://maps.googleapis.com', '/maps/api/geocode/json?latlng=' + lat + ',' + lng + '&key=' + gmaps_georeverse_key.current)
        // console.log('aux_georeverse', aux_georeverse)
        // console.log('aux_georeverse.results', aux_georeverse.results)
        if(aux_georeverse?.results !== undefined && aux_georeverse?.results !== null && Array.isArray(aux_georeverse.results) && aux_georeverse.results.length > 0) {
            set_dados(location_name.current = aux_georeverse.results[0])
        }

    }

    const handleGetLocationByAddress = async () => {

        console.log('dados.current', dados.current)
        let address = dados.current.info.zip_code + ',' + dados.current.info.address + ',' + dados.current.info.location



        let aux_georeverse = await simpleAxiosGet('https://maps.googleapis.com', '/maps/api/geocode/json?address=' + address + '&extra_computations=ADDRESS_DESCRIPTORS&key=' + gmaps_georeverse_key.current)
        // console.log('aux_georeverse', aux_georeverse)
        // console.log('aux_georeverse.results', aux_georeverse.results)
        if(aux_georeverse?.results !== undefined && aux_georeverse?.results !== null && Array.isArray(aux_georeverse.results) && aux_georeverse.results.length > 0) {
            setLocation({lat: aux_georeverse.results[0].geometry.location.lat, lng: aux_georeverse.results[0].geometry.location.lng})
            setDefaultLocation({lat: aux_georeverse.results[0].geometry.location.lat, lng: aux_georeverse.results[0].geometry.location.lng})

            set_dados(location_name.current = aux_georeverse.results[0])

        }

    }
    
    function handleChangeZoom (newZoom){
        setZoom(newZoom);
    }
    // MAPA

    useEffect(() => {

        (async () => {

            let aux_location = {
                lat: 10, 
                lng: 16
            }

            let aux_settings = await reqGET(`${Hosts.SIMCore_API}/web/config/attributes/type/${Hosts.companycode}/website_settings`) 
            if(aux_settings.data !== undefined && aux_settings.data !== null && aux_settings.data.length > 0) {
                set_dados(gmaps_key.current = aux_settings.data[0].info.settings.gmaps_key)
                set_dados(gmaps_georeverse_key.current = aux_settings.data[0].info.settings.gmaps_georeverse_key)
            }

            if(props !== undefined && props !== null && props !== '') {
                set_dados(dados_config.current = props.dados_config)

                if(dados_config.current.content[0].contacts.gps !== undefined && dados_config.current.content[0].contacts.gps.lat !== '' && dados_config.current.content[0].contacts.gps.lng !== '') {
                    aux_location = {
                        lat: parseFloat(dados_config.current.content[0].contacts.gps.lat), 
                        lng: parseFloat(dados_config.current.content[0].contacts.gps.lng)
                    }
                }
            }
            setDefaultLocation(aux_location)
            await handleChangeLocation(aux_location.lat, aux_location.lng)

            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })

            setLoading(false)

        })()
    
    }, [props]); 

    const [agree, setAgree] = useState(false);

    const checkboxHandler = () => {
      // if agree === true, it will be set to false
      // if agree === false, it will be set to true
      setAgree(!agree);
      // Don't miss the exclamation mark
    }

    const checkboxHandler_reload = (agree) => {
        //console.log('AGREE', agree)
        if (agree === true)
            return true
        else 
            return false
        // if agree === false, it will be set to true
        //setAgree(!agree);
        // Don't miss the exclamation mark
      }

    const [counterText, setCounterText] = useState('');

    const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)
        console.log('Dados Current:' + JSON.stringify(dados))

    }

    const handle_onblur_info = () => {
        console.log('handle_onblur_info')
        
        if(dados.current.info.address !== '' && dados.current.info.zip_code !== '' && dados.current.info.location !== '') {
            handleGetLocationByAddress()
        }

    }

    const handle_change_info_textarea = (e) => {
        const { name, value } = e.target;
        //console.log('NAME ', name)
        //console.log('VALUE ', value)
        setCounterText(e.target.value)

        set_dados(dados.current.info[name] = value)
        //set_dados(dados.current.info.date.creation = new Date())
        //console.log('Dados Current:' + JSON.stringify(dados))
    }

    const handleSubmit = async e => {
        e.preventDefault();

        //alert('SUBMIT');
        //return;

        let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +';border:1px solid transparent;border-collapse:collapse;">' +
            '<tr style="border-collapse: collapse;">' +
                '<td align="left" class style="padding:40px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                    '<div>'+
                        '<h4>'+ language[lang].contact_form +':</h4>'+
                        '<span><b>'+ language[lang].name +': </b><label>' + dados.current.info.name + '</label></span>' +
                        '<br/>'+
                        '<span"><b>Email: </b><label>' + dados.current.info.email + '</label></span>'+
                        '<br/>'+
                        '<span"><b>Tlf./Tlm.: </b><label>' + dados.current.info.tlf + '</label></span>'+
                        '<br/>'+
                        '<span"><b>NIF: </b><label>' + dados.current.info.nif + '</label></span>'+
                        '<br/>'+
                        '<span><b>'+ language[lang].adress +': </b><label>' + dados.current.info.address + '</label></span>' +
                        '<br/>'+
                        '<span><b>'+ language[lang].zip_code +': </b><label>' + dados.current.info.zip_code + '</label></span>' +
                        '<br/>'+
                        '<span><b>'+ language[lang].location +': </b><label>' + dados.current.info.location + '</label></span>' +
                        '<br/>'+
                        '<span"><b>Lat: </b><label>' + location.lat + '</label></span>'+
                        '<br/>'+
                        '<span"><b>Lng: </b><label>' + location.lng + '</label></span>'+
                        '<br/>'+
                        '<span><b>'+ language[lang].user +': </b><label>' + language[lang]['type_' + dados.current.info.type_user] + '</label></span>' +
                        '<br/>'+
                        /*'<span><b>'+ language[lang].subject +': </b><label>' + dados.current.info.subject + '</label></span>' +
                        '<br/>'+*/
                        '<br/>' +
                        '<span><b>'+ language[lang].message +': </b><label>' + dados.current.info.message + '</label></span>' +
                        '<br/>'+
                    '</div>'+
                '</td>' +
            '</tr>' +
        '</table>'

        set_file_url('1')
        let attachment = {};

        if(upload_file !== undefined) {
            await uploadFile(upload_file)
                .then(async (res) => {
                    set_file_url(res)
                    attachment = 
                        {   // encoded string em Base 64
                            filename: files_doc_name,
                            //filename: 'logo.svg',
                            path: res,
                            //path: file_base64,
                            //path: 'https://temp.assec.pt/repo/turistrela/website/static/assets/logo/logo.svg',
                        }
                    
                    //mailOptions.attachments[0].path = res

                    functionSendMail(dados_config.current.content[0].contacts.email_form, [dados.current.info.email], [dados_config.current.content[0].contacts.email_form], dados_config.current.info.name + ' - ' + language[lang].contact_form, mail_content, attachment, dados_config)
                        .then((res2) => {
                            if(res2 === true) {
                                set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
                                document.getElementById('agree').checked = false
                                setAgree(false)
                                //setRefresh(refresh + 1)
                                set_file_url('')
                                Swal.fire({
                                    title: language[lang].contact_form,
                                    text: language[lang].sent_successfully,
                                    icon: 'success',
                                    //showCancelButton: true,
                                    confirmButtonColor: '#08396a',
                                    //confirmButtonText: 'Tentar novamente',
                                    })
                            }
                            else {
                                console.log('erro')
                            }
                        })

                    /*reqPOST(`${Hosts.SIMCore_API_MAIL}`, {data: mailOptions})
                        .then(() => { 
                            //console.log('Notificações enviadas com sucesso') 
                            set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
                            document.getElementById('agree').checked = false
                            setAgree(false)
                            //setRefresh(refresh + 1)
                            set_file_url('')
                            Swal.fire({
                                title: language[lang].contact_form,
                                text: language[lang].sent_successfully,
                                icon: 'success',
                                //showCancelButton: true,
                                confirmButtonColor: '#08396a',
                                //confirmButtonText: 'Tentar novamente',
                            })
                    
                        })
                        .catch((error) => console.log(error))*/
                
                })
        } else {

            functionSendMail(dados_config.current.content[0].contacts.email_form, [dados.current.info.email], [dados_config.current.content[0].contacts.email_form], dados_config.current.info.name + ' - ' + language[lang].contact_form, mail_content, attachment, dados_config)
                .then((res2) => {
                    if(res2 === true) {
                        set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
                        document.getElementById('agree').checked = false
                        setAgree(false)
                        //setRefresh(refresh + 1)
                        set_file_url('')
                        Swal.fire({
                            title: language[lang].contact_form,
                            text: language[lang].sent_successfully,
                            icon: 'success',
                            //showCancelButton: true,
                            confirmButtonColor: '#08396a',
                            //confirmButtonText: 'Tentar novamente',
                            })
                    }
                    else {
                        console.log('erro')
                    }
                })

        }

    }

    const onChangeHandlerFile = async (e) => {
        const { files } = e.target;

        // set_is_uploading('')
        set_upload_file(files[0])

        // setTimeout(function(){
            // set_file_url(res)
            set_files_doc_name(files[0].name)
            set_files_doc(e)
            // set_is_uploading(' d-none')
        // }, 5000);


        /*
        await uploadFile(files[0])
            .then(async (res) => {

                setTimeout(function(){
                    set_file_url(res)
                    set_files_doc_name(files[0].name)
                    set_files_doc(e)
                    set_is_uploading(' d-none')
                }, 5000);

            })
        */
        /*
        convertBase64(files[0])
            .then((res) => {
                set_file_base64(res)
                set_files_doc_name(files[0].name)
                set_files_doc(e)
            })
        */
    }

    const uploadFile = async (file) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', '')
		formData.append('file_name', file.name)
		formData.append('type', 'tmp')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/tmp/');

		return await reqFILE(`${Hosts.SIMCore_API}/multimedia/file`, formData)
			.then(async (res) => {


                set_file_url(res.data.path + '/' + res.data.name)
                set_files_doc_name(file.name)
                set_files_doc(file)
                // set_is_uploading(' d-none')

				return res.data.path + '/' + res.data.name

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

    /*
    const convertBase64 = async (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);

			fileReader.onload = () => {
				resolve(fileReader.result);
			};

			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};
    */

    return (
        isloading ?
            null
        :
            <div className="row mt-3">
                <div className={file_url === '' ? 'd-none' : ''}>
                    <Loader />
                </div>
                <div className="col-12 col-md-8 mx-auto text-center mb-5">
                    {parse(language[lang].energy_form_text)}
                </div>
                <div className="col-12 mx-auto">
                    <form className='form-container' onSubmit={handleSubmit}>
                        <div className="row">
                            <div className='col-12 col-lg-7 mb-3 order-lg-2'>
                                <div className='row'>

                                    <div className="col-12 mb-3">
                                        {language[lang].read_terms_conditions}
                                    </div>
                                    <div className="col-12 col-sm-6 mb-3">
                                        <label className="form-label visually-hidden" htmlFor="name">{language[lang].name}*</label>
                                        <input id="name" type="text" name="name" value={dados.current.info.name} className="form-control" placeholder={language[lang].name + " *"} onChange={handle_change_info} required />
                                    </div>
                                    <div className="col-12 col-sm-6 mb-3">
                                        <label className="form-label visually-hidden" htmlFor="email">{language[lang].email}*</label>
                                        <input id="email" type="email" name="email" 
                                            value={dados.current.info.email} 
                                            className="form-control" 
                                            placeholder={language[lang].email + " *"} 
                                            onChange={handle_change_info} required
                                        /> 
                                    </div>
                                    <div className="col-12 col-sm-6 mb-3">
                                        <label htmlFor="tlf" className="form-label visually-hidden">Tlf./Tlm. *</label>
                                        <input type="text" name="tlf" id="tlf" 
                                            pattern="[0-9]{9}" 
                                            value={dados.current.info.tlf} 
                                            className="form-control" 
                                            placeholder="Tlf./tlm. *" 
                                            onChange={handle_change_info}
                                            required
                                        />
                                    </div>
                                    <div className="col-12 col-sm-6 mb-3">
                                        <label className="form-label visually-hidden" htmlFor="nif">{language[lang].dados_vat}*</label>
                                        <input id="nif" type="text" name="nif"
                                            pattern="[0-9]{9}" 
                                            value={dados.current.info.nif} 
                                            className="form-control" 
                                            placeholder={language[lang].dados_vat} 
                                            onChange={handle_change_info}
                                        /> 
                                    </div>
                                    <div className="col-12 mb-3">
                                        <label className="form-label visually-hidden" htmlFor="address">{language[lang].adress}*</label>
                                        <input id="address" type="text" name="address" 
                                            value={dados.current.info.address}
                                            className="form-control" 
                                            placeholder={language[lang].adress + " *"} 
                                            onChange={handle_change_info} 
                                            // onBlur={handle_onblur_info} 
                                            required
                                        /> 
                                    </div>
                                    <div className="col-12 col-md-6 mb-3">
                                        <label htmlFor="zip_code" className="form-label visually-hidden">{language[lang].zip_code}*</label>
                                        <input 
                                            type="text" 
                                            name="zip_code"
                                            id="zip_code" 
                                            value={dados.current.info.zip_code}
                                            pattern="[0-9]{4}-[0-9]{3}" 
                                            className="form-control" 
                                            placeholder={language[lang].zip_code + " *"}
                                            onChange={handle_change_info}
                                            // onBlur={handle_onblur_info} 
                                            required 
                                        />
                                    </div>
                                    <div className="col-12 col-sm-6 mb-3">
                                        <label htmlFor="location" className="form-label visually-hidden">{language[lang].location}*</label>
                                        <div className="input-group mb-3">
                                            <input
                                                type="text" 
                                                name="location" 
                                                id="location" 
                                                value={dados.current.info.location}
                                                className="form-control" 
                                                placeholder={language[lang].location + " *"}
                                                onChange={handle_change_info}
                                                // onBlur={handle_onblur_info} 
                                                required
                                            />
                                            <button className="btn btn-secondary" type="button" onClick={() => handle_onblur_info()}>
                                                <i className="bi bi-arrow-right"></i>
                                            </button>
                                        </div>

                                    </div>
                                    <div className="col-12 col-sm-6 mb-3 d-none">
                                        <label className="form-label visually-hidden" htmlFor="gps_lat">Latitute</label>
                                        <input id="gps_lat" type="text" name="gps_lat" 
                                            value={dados.current.info.gps_lat} 
                                            className="form-control" 
                                            placeholder={"Latitude"} 
                                            onChange={handle_change_info}
                                        /> 
                                    </div>
                                    <div className="col-12 col-sm-6 mb-3 d-none">
                                        <label className="form-label visually-hidden" htmlFor="gps_lng">Longitude</label>
                                        <input id="gps_lng" type="text" name="gps_lng" 
                                            value={dados.current.info.gps_lng} 
                                            className="form-control" 
                                            placeholder={"Longitude"} 
                                            onChange={handle_change_info}
                                        /> 
                                    </div>
                                    <div className="col-12 mb-3">
                                        <div className='form-label'>
                                            <strong>
                                                {language[lang].type_label}
                                            </strong>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                id="radio_0"
                                                type="radio"
                                                name="type_user"
                                                value="consumer"
                                                defaultChecked={dados.current.info.type_user === 'consumer' ? true : false}
                                                onChange={handle_change_info}
                                            />
                                            <label className="form-check-label" htmlFor="radio_0">{language[lang].type_consumer}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                id="radio_1"
                                                type="radio"
                                                name="type_user"
                                                value="producer"
                                                defaultChecked={dados.current.info.type_user === 'producer' ? true : false}
                                                onChange={handle_change_info}
                                            />
                                            <label className="form-check-label" htmlFor="radio_1">{language[lang].type_producer}</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                id="radio_2"
                                                type="radio"
                                                name="type_user"
                                                value="unknown"
                                                defaultChecked={dados.current.info.type_user === 'unknown' ? true : false}
                                                onChange={handle_change_info}
                                            />
                                            <label className="form-check-label" htmlFor="radio_2">{language[lang].type_unknown}</label>
                                        </div>
                                    </div>

                                    {/*
                                    <div className="col-12 mb-3">
                                        <label className="form-label visually-hidden" htmlFor="subject">{language[lang].subject}*</label>
                                        <input id="subject" type="subject" name="subject" 
                                            value={dados.current.info.subject} 
                                            className="form-control" 
                                            placeholder={language[lang].subject + " *"} 
                                            onChange={handle_change_info} required
                                        /> 
                                    </div>
                                    */}

                                    <div className="col-12 mb-3">
                                        <label className="form-label" htmlFor={"input-files-pdf-0"}>
                                            <strong>
                                                Anexar fatura
                                            </strong>
                                        </label>
                                        <input
                                            id={"input-files-pdf-0"}
                                            name="docs"
                                            className="form-control"
                                            //defaultValue={files_doc_name[0] !== undefined ? files_doc_name[0].name : ''}
                                            type="file"
                                            accept="application/pdf,image/jpeg, image/png"
                                            onChange={(e) => onChangeHandlerFile(e)}
                                            //disabled={(dados.current.info.vat === '' || dados.current.info.course.id === '')}
                                            //multiple
                                            //required
                                        />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label visually-hidden" htmlFor="message">{language[lang].message}</label>
                                        <textarea
                                            style={{ height: "180px", width: "100%" }}
                                            id="message"
                                            name="message"
                                            className="form-control"
                                            placeholder={language[lang].message}
                                            maxLength="600"
                                            value={dados.current.info.message}
                                            onChange={handle_change_info_textarea}
                                        />
                                        <div className="text-end my-2 small">
                                            {language[lang].maximum_numbers_of_caracters}&#58;&nbsp;{counterText.length}/600
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            <div className="col-12 col-lg-5 mb-3 order-lg-1">
                                <div className='info-container'>
                                    <div className='flex-align-items mb-3'>
                                        <>
                                            <div className=''>
                                                <p>
                                                    <strong>
                                                        {language[lang].adress}
                                                    </strong>
                                                </p>
                                            </div>

                                            <div className='d-none'>
                                                <p>
                                                    {location_name?.current?.formatted_address ? location_name.current.formatted_address : ''}
                                                </p>
                                            </div>

                                            <MapPicker 
                                                defaultLocation={defaultLocation}
                                                zoom={zoom}
                                                mapTypeId="satellite"
                                                style={{height:'400px'}}
                                                onChangeLocation={handleChangeLocation} 
                                                onChangeZoom={handleChangeZoom}
                                                apiKey={gmaps_key.current}
                                            />

                                            <div className='m-2 mt-3'>
                                                <p>
                                                    <i className="bi bi-exclamation-triangle me-2"></i>
                                                    {language[lang].map_warning}
                                                </p>
                                            </div>
                                        </>       
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 col-lg-7 offset-lg-5 mb-3 order-lg-3'>
                                <div className='row'>
                                    <div className="col-12">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" id="agree" onChange={checkboxHandler} defaultChecked={checkboxHandler_reload(agree)}/>
                                            <label className="form-check-label small" htmlFor="agree">{language[lang].agree_terms_conditions}</label>&nbsp;
                                            {
                                                lang !== 'pt' && dados_config.current.content !== undefined && dados_config.current.content[0]?.terms !== undefined && Object.keys(dados_config.current.content[0]?.terms).length > 0 && dados_config.current.content[0]?.terms[lang_id] !== undefined && dados_config.current.content[0]?.terms[lang_id] !== null && dados_config.current.content[0]?.terms[lang_id] !== '' ?
                                                    <a className="small" href={dados_config.current.content[0]?.terms[lang_id]?.link} aria-label={"Link - " + language[lang].terms_conditions + " (opens a new window)"} title={"Link - " + language[lang].terms_conditions} target="_blank" rel="noreferrer">
                                                        {language[lang].terms_conditions_link}
                                                    </a>
                                                :
                                                    dados_config.current.content !== undefined && dados_config.current.content[0]?.terms !== undefined && Object.keys(dados_config.current.content[0]?.terms).length > 0 && dados_config.current.content[0]?.terms['1'] !== null && dados_config.current.content[0]?.terms['1'] !== '' ?
                                                        <a className="small" href={dados_config.current.content[0]?.terms['1']?.link} aria-label={"Link - " + language[lang].terms_conditions + " (opens a new window)"} title={"Link - " + language[lang].terms_conditions} target="_blank" rel="noreferrer">
                                                            {language[lang].terms_conditions_link}
                                                        </a>
                                                    :
                                                        <a className="small pe-none" href='!#' target="_blank" rel="noreferrer">
                                                            {language[lang].terms_conditions_link}
                                                        </a>
                                            }
                                            {/*<a className="small" href={Hosts.WEB_SITE_URI + "terms-conditions"} target="_blank" rel="noreferrer">{language[lang].terms_conditions_link}</a>*/}
                                        </div>
                                        <div className="small">{language[lang].terms_conditions_required}</div>
                                    </div>

                                    <div className='col-12 text-end mt-5 order-lg-3'>
                                        {/*{console.log('AGREE2', agree)}
                                        {console.log('MAIL: ', JSON.stringify(mailOptions))}*/}
                                        <Button disabled={!agree} className="mx-auto" color="primary">{language[lang].send}</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
    );


};

export default EnergyForm;